import React from "react";

const PageNotFound = () => {
  return (
    <div className="page-not-found">
      <h1>404</h1>
      <h3>Page Not Found</h3>
      <p className="mt-3">Sorry, the page you are looking for could not be found.</p>
    </div>
  );
};

export default PageNotFound;
